// Structured data (JSON-LD) for SEO

export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "@id": "https://miskkargo.com/#organization",
  name: "Misk Cargo",
  alternateName: ["مسك كارجو", "مسك للشحن", "Misk Kargo"],
  url: "https://miskkargo.com",
  logo: "https://miskkargo.com/logo.png",
  image: "https://miskkargo.com/og-image.png",
  description: "International shipping solutions from Turkey and China to Syria. Reliable logistics partner for traders and businesses.",
  email: "miskexport963@gmail.com",
  telephone: "+905521627900",
  address: [
    {
      "@type": "PostalAddress",
      streetAddress: "Başakşehir - Rami New Market",
      addressLocality: "Istanbul",
      addressCountry: "TR"
    },
    {
      "@type": "PostalAddress",
      streetAddress: "Zablatani",
      addressLocality: "Damascus",
      addressCountry: "SY"
    },
    {
      "@type": "PostalAddress",
      streetAddress: "Nuqarin",
      addressLocality: "Aleppo",
      addressCountry: "SY"
    }
  ],
  sameAs: [
    "https://www.facebook.com/miskcargo",
    "https://www.instagram.com/miskcargo.tr",
    "https://t.me/pMpv2lkJs78zOTVk",
    "https://wa.me/905521627900"
  ],
  areaServed: [
    {
      "@type": "Country",
      name: "Turkey"
    },
    {
      "@type": "Country",
      name: "China"
    },
    {
      "@type": "Country",
      name: "Syria"
    }
  ],
  serviceType: [
    "International Shipping",
    "Freight Forwarding",
    "Customs Clearance",
    "Warehousing",
    "Logistics Services"
  ]
};

export const localBusinessSchema = (location) => {
  const locations = {
    istanbul: {
      name: "Misk Cargo Istanbul Office",
      address: {
        "@type": "PostalAddress",
        streetAddress: "Şahintepe Mah., Lalezar Sk., Başakşehir",
        addressLocality: "Istanbul",
        addressRegion: "Istanbul",
        postalCode: "34494",
        addressCountry: "TR"
      },
      telephone: "+905521627900",
      geo: {
        "@type": "GeoCoordinates",
        latitude: "41.0858302",
        longitude: "28.7240739"
      }
    },
    damascus: {
      name: "Misk Cargo Damascus Office",
      address: {
        "@type": "PostalAddress",
        streetAddress: "Zablatani",
        addressLocality: "Damascus",
        addressCountry: "SY"
      },
      telephone: "+963945184737",
      geo: {
        "@type": "GeoCoordinates",
        latitude: "33.5045441",
        longitude: "36.3141394"
      }
    },
    aleppo: {
      name: "Misk Cargo Aleppo Office",
      address: {
        "@type": "PostalAddress",
        streetAddress: "Nuqarin",
        addressLocality: "Aleppo",
        addressCountry: "SY"
      },
      telephone: "+963964355325",
      geo: {
        "@type": "GeoCoordinates",
        latitude: "36.218471",
        longitude: "37.237655"
      }
    }
  };

  const loc = locations[location] || locations.istanbul;

  return {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "@id": `https://miskkargo.com/#${location}`,
    name: loc.name,
    image: "https://miskkargo.com/logo-dark.png",
    url: "https://miskkargo.com",
    telephone: loc.telephone,
    email: "miskexport963@gmail.com",
    address: loc.address,
    geo: loc.geo,
    openingHoursSpecification: {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday"
      ],
      opens: "08:00",
      closes: "20:00"
    },
    priceRange: "$$"
  };
};

export const serviceSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  serviceType: "International Shipping and Logistics",
  provider: {
    "@type": "Organization",
    name: "Misk Cargo",
    url: "https://miskkargo.com"
  },
  areaServed: [
    {
      "@type": "Country",
      name: "Turkey"
    },
    {
      "@type": "Country",
      name: "China"
    },
    {
      "@type": "Country",
      name: "Syria"
    }
  ],
  hasOfferCatalog: {
    "@type": "OfferCatalog",
    name: "Shipping Services",
    itemListElement: [
      {
        "@type": "Offer",
        itemOffered: {
          "@type": "Service",
          name: "Shipping from Turkey to Syria",
          description: "Regular shipping routes from Istanbul to Damascus and Aleppo via land and sea freight"
        }
      },
      {
        "@type": "Offer",
        itemOffered: {
          "@type": "Service",
          name: "Shipping from China to Syria",
          description: "Direct imports from major Chinese cities with full supplier follow-up"
        }
      },
      {
        "@type": "Offer",
        itemOffered: {
          "@type": "Service",
          name: "Customs Clearance",
          description: "Fast customs clearance services with specialized team"
        }
      },
      {
        "@type": "Offer",
        itemOffered: {
          "@type": "Service",
          name: "Warehousing Services",
          description: "Modern warehouses in Istanbul, Damascus and Aleppo with smart management"
        }
      },
      {
        "@type": "Offer",
        itemOffered: {
          "@type": "Service",
          name: "Consolidation and Packing",
          description: "Multi-supplier consolidation and professional repacking services"
        }
      }
    ]
  }
};

export const breadcrumbSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((item, index) => ({
    "@type": "ListItem",
    position: index + 1,
    name: item.name,
    item: `https://miskkargo.com${item.url}`
  }))
});

export const faqSchema = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map(faq => ({
    "@type": "Question",
    name: faq.question,
    acceptedAnswer: {
      "@type": "Answer",
      text: faq.answer
    }
  }))
});

export const webPageSchema = (title, description, url) => ({
  "@context": "https://schema.org",
  "@type": "WebPage",
  "@id": `https://miskkargo.com${url}`,
  url: `https://miskkargo.com${url}`,
  name: title,
  description: description,
  isPartOf: {
    "@type": "WebSite",
    "@id": "https://miskkargo.com/#website",
    url: "https://miskkargo.com",
    name: "Misk Cargo"
  },
  inLanguage: ["ar", "en", "tr", "zh-CN"],
  potentialAction: {
    "@type": "ReadAction",
    target: [`https://miskkargo.com${url}`]
  }
});

export const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "@id": "https://miskkargo.com/#website",
  url: "https://miskkargo.com",
  name: "Misk Cargo",
  description: "International shipping solutions from Turkey and China to Syria",
  publisher: {
    "@type": "Organization",
    name: "Misk Cargo",
    logo: {
      "@type": "ImageObject",
      url: "https://miskkargo.com/logo-dark.png"
    }
  },
  inLanguage: ["ar", "en", "tr", "zh-CN"],
  potentialAction: {
    "@type": "SearchAction",
    target: {
      "@type": "EntryPoint",
      urlTemplate: "https://miskkargo.com/?s={search_term_string}"
    },
    "query-input": "required name=search_term_string"
  }
};

/* Every branch as a LocalBusiness with exact coordinates (see lib/branches.js). */
export const branchesSchema = (branches) =>
  branches.map((b) => ({
    "@type": "LocalBusiness",
    "@id": `https://miskkargo.com/#branch-${b.id}`,
    name: `Misk Cargo ${b.locality.split(",")[0]}${b.id.includes("warehouse") ? " Warehouse" : ""}`,
    parentOrganization: { "@id": "https://miskkargo.com/#organization" },
    image: "https://miskkargo.com/og-image.png",
    url: "https://miskkargo.com/contact",
    telephone: b.phone,
    address: {
      "@type": "PostalAddress",
      streetAddress: b.street,
      addressLocality: b.locality,
      ...(b.postalCode ? { postalCode: b.postalCode } : {}),
      addressCountry: b.country,
    },
    geo: { "@type": "GeoCoordinates", latitude: b.lat, longitude: b.lng },
    hasMap: `https://www.google.com/maps?q=${b.lat},${b.lng}`,
  }));
